var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('tarefas',{staticClass:"task-layout-inline",attrs:{"layout":"inline","relacao-entidade":"negocio","relacao-entidade-id":_vm.parseProps.negocio.id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }